/* ÜRETİLMİŞ DOSYA — ELLE DÜZENLEMEYİN.
   Kaynak: ris-api/RIS.UI/src/shared/template-builder
   Güncelleme: ris-api/scripts/sync-template-builder.sh */

import { Alert, Badge, List, Typography } from 'antd'
import { useMemo } from 'react'
import { collectTokens, missingTranslationCount } from '../model'

/**
 * Kaydetmeden önce görünen uyarı paneli.
 *
 * v1'de doldurulamayan alan sessizce yutuluyordu (SetNoticeAboutErrors(false)); burada tanınmayan alanlar
 * ve eksik çeviriler kullanıcıya önden gösterilir. Sunucu tarafı doğrulama (Validate ucu) kaydetme
 * anında ayrıca çalışır — bu panel yalnızca istemci tarafı hızlı geri bildirimdir.
 */
export default function ValidationPanel({ definition, placeholders = [], t = (x) => x }) {
    const known = useMemo(
        () => new Set(placeholders.map((p) => String(p.token || '').replace(/\s/g, '').toLowerCase())),
        [placeholders]
    )

    const unknownTokens = useMemo(() => {
        return collectTokens(definition).filter(
            (token) => !known.has(String(token).replace(/\s/g, '').toLowerCase())
        )
    }, [definition, known])

    const missing = useMemo(
        () =>
            (definition.languages || [])
                .map((language) => ({ language, count: missingTranslationCount(definition, language) }))
                .filter((x) => x.count > 0),
        [definition]
    )

    if (unknownTokens.length === 0 && missing.length === 0) {
        return <Alert type="success" showIcon message={t('Sorun görünmüyor')} />
    }

    return (
        <>
            {unknownTokens.length > 0 && (
                <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: 8 }}
                    message={t('Tanınmayan alanlar')}
                    description={
                        <>
                            <Typography.Paragraph type="secondary" style={{ marginBottom: 4 }}>
                                {t('Bu alanlar katalogda yok; çıktıda boş kalırlar.')}
                            </Typography.Paragraph>
                            <List
                                size="small"
                                dataSource={unknownTokens}
                                renderItem={(token) => <List.Item><code>{token}</code></List.Item>}
                            />
                        </>
                    }
                />
            )}

            {missing.length > 0 && (
                <Alert
                    type="info"
                    showIcon
                    message={t('Eksik çeviriler')}
                    description={
                        <List
                            size="small"
                            dataSource={missing}
                            renderItem={(item) => (
                                <List.Item>
                                    <Badge status="warning" />
                                    {item.language.toUpperCase()} — {item.count} {t('blok')}
                                </List.Item>
                            )}
                        />
                    }
                />
            )}
        </>
    )
}